import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { ParagraphComponentContext } from './paragraph-context.interface';

@Component({
    templateUrl: './paragraph.component.html',
    styleUrls: ['./paragraph.component.min.css'],
})
export class ParagraphComponent implements BuildingBlockInterface {
    @Input() public context: ParagraphComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/paragraph/paragraph.component.ts